<script lang="ts">
  import { page } from '$app/stores';
  import ShareIcon from '$lib/assets/icons/ShareIcon.svelte';
  import { sendAnalyticsEvent } from '$lib/services/analytics';
  import { EventNames } from '$lib/types/analytics';
  import { onShare, sendContentSharedEvent } from '$lib/utils/share';

  export let url: string;
  const shareColor = '#ffffff';
</script>

<button
  class="share-wrapper"
  on:click|stopPropagation|preventDefault={() => {
    sendAnalyticsEvent(EventNames.SHARE_CLICK, { url });
    // try {
    // window.MySitesAndroidInterface.onShare(`${$page.url.origin}${url}`);
    // } catch (error) {
    onShare({ url }, sendContentSharedEvent);
    // }
  }}
>
  <ShareIcon --color={shareColor} />
</button>

<style lang="scss">
  .share-wrapper {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: rgba(20, 25, 35, 0.4);
    border: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
